import React from 'react';
import { Button, Paper, Typography } from '@mui/material';

import { PropertiesPanel } from '@paragon/layout-models';
import { DistanceField } from '@paragon/material';

import { adjustComponentSpan } from '../../../../store/actions/editComponentActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getActiveComponentSpans } from '../../../../store/selectors/getActiveComponentSpansSelector';
import { propertiesShouldBeViewOnly } from '../../../../store/selectors/viewOnlyModeSelectors';
import { setTrussEditsPanel } from '../../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export function SpanMacrosPanel() {
  const dispatch = useAppDispatch();

  const isViewOnly = useAppSelector(propertiesShouldBeViewOnly);

  const componentDesign = useAppSelector(getActiveComponentDesign);
  const componentSpans = useAppSelector(getActiveComponentSpans);

  if (componentDesign == null) return null;

  const adjustComponentSpanFromPreviousValue = (oldValue: number) => (newValue: number) => {
    const difference = newValue - oldValue;

    // Distance is in inches, so this is our tolerance to avoid spurious macro changes.
    return Math.abs(difference) > 1 / 16
      ? dispatch(adjustComponentSpan(difference, componentDesign!.guid))
      : Promise.resolve();
  };

  if (componentSpans == null) {
    return (
      <PropertiesPanel title="Adjust Span">
        <Typography>Unable to adjust spans for this component.</Typography>
      </PropertiesPanel>
    );
  }

  return (
    <PropertiesPanel title="Adjust Span">
      <DistanceField
        label="Bearing Span"
        disabled={isViewOnly}
        onSubmit={adjustComponentSpanFromPreviousValue(componentSpans.bearingSpan)}
        value={componentSpans.bearingSpan}
        min={0}
      />

      <DistanceField
        label="Bottom Chord Length"
        disabled={isViewOnly}
        onSubmit={adjustComponentSpanFromPreviousValue(componentSpans.bottomChordLength)}
        value={componentSpans.bottomChordLength}
        min={0}
      />

      <DistanceField
        label="Overall Length"
        disabled={isViewOnly}
        onSubmit={adjustComponentSpanFromPreviousValue(componentSpans.overallLength)}
        value={componentSpans.overallLength}
        min={0}
      />

      <Paper elevation={1} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', p: 1, borderRadius: 0 }}>
        <Button
          variant="outlined"
          onClick={() => {
            dispatch(setTrussEditsPanel(null));
          }}
        >
          Close
        </Button>
      </Paper>
    </PropertiesPanel>
  );
}
